/**
 * @file workflow.js
 * @description Shared workflow step configuration for the sidebar. No UI impact.
 */
export const WORKFLOW_STEPS = [
  { key: 'screenplay', label: 'Screenplay', models: ['GPT-4o', 'Gemini 1.5', 'Claude 3'] },
  { key: 'characterBible', label: 'Characters', models: ['GPT-4o', 'Gemini 1.5', 'Claude 3'] },
  { key: 'scenes', label: 'Scenes', models: ['GPT-4o', 'Gemini 1.5', 'Claude 3'] },
  { key: 'videos', label: 'Videos', models: ['VEO 3.0', 'Runway', 'Pika'] },
  { key: 'merge', label: 'Merge', models: ['FFMPEG'] }
];
